import { noop } from '@/utils/util';
import loadingImg from '@/assets/images/tiny.gif';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import Immutable from 'immutable';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import { Tooltip } from 'antd';
import styles from './EditorToolBar.scss';

import { isFirefox } from '../../utils/browserDetector';

@withRouter
export default class EditorToolBar extends Component {
  static propTypes = {
    isNoteShared: PropTypes.bool.isRequired, // 文章状态
    isPreviewMode: PropTypes.bool,
    isWritingMode: PropTypes.bool.isRequired, // 是否为写作模式，用于filter出合适的item
    contentChanged: PropTypes.bool.isRequired, // 文章内容是否有变化
    isPublishing: PropTypes.bool, // 文章是否正在发布
    isAutoSaving: PropTypes.bool, // 文章是否正在保存
    customerClass: PropTypes.string, // 自定义样式
    isMarkDown: PropTypes.bool,
    isAudioExist: PropTypes.bool, // 文章内是否有音频文件
  };

  static defaultProps = {
    onToolItemClick: noop,
    isPublishing: false,
    isAutoSaving: false,
    isPreviewMode: false,
  };

  constructor(props) {
    super(props);
    const { isWritingMode, isPreviewMode } = this.props;
    this.markDownToolItems = [
      {
        foldIndex: 1000, // 不折叠
        fa: 'picture-o',
        tip: 'picture',
        action: 'openImageModal',
      },
      {
        foldIndex: 1000,
        fa: 'undo',
        tip: 'undo',
        action: 'undo',
      },
      {
        foldIndex: 1000,
        fa: 'repeat',
        tip: 'redo',
        action: 'redo',
      },
      {
        foldIndex: 1000,
        fa: 'history',
        tip: 'history',
        action: 'to-history',
      },
      {
        foldIndex: 1000,
        fa: 'volume-up',
        tip: 'audio',
        action: 'openAudioModal',
      },
      {
        foldIndex: 1000,
        fa: 'volume-off',
        tip: 'audioExist',
        action: 'openAudioModal',
      },
      {
        foldIndex: 1000,
        fa: 'file-o',
        tip: 'grammar',
        action: 'openGrammarModal',
      },
      {
        foldIndex: 1000,
        fa: 'expand',
        tip: 'expand',
        action: 'to-fullscreen',
        float: true,
      },
      {
        foldIndex: 1000,
        fa: 'compress',
        tip: 'compress',
        action: 'exit-fullscreen',
        float: true,
      },
      {
        foldIndex: 1000,
        fa: 'columns',
        tip: isPreviewMode ? 'to-normal-mode' : 'preview',
        action: 'to-preview',
        float: true,
      },
      {
        foldIndex: 1000,
        fa: 'floppy-o',
        tip: 'save',
        action: 'auto-save',
        float: true,
      },
    ];
    // 富文本的工具栏选项配置
    this.richTextToolItems = [
      {
        foldIndex: 3, // 折叠优先级，数字越小越早折叠
        fa: 'bold', // 折叠时展示的fontawsome
        text: '', // 没有fa时展示时用文本展示
        ul: [ // 展开的所有选项
          {
            fa: 'bold',
            action: 'bold',
            tip: 'bold',
          },
          {
            fa: 'italic',
            tip: 'italic',
            action: 'italic',
          },
          {
            fa: 'strikethrough',
            tip: 'strikethrough',
            action: 'strikethrough',
          },
          {
            fa: 'quote-left',
            tip: 'quote',
            action: 'insertBlockquote',
          },
        ],
      },
      {
        foldIndex: 1000, // 不折叠
        fa: 'picture-o',
        tip: 'picture',
        action: 'openImageModal',
      },
      {
        foldIndex: 2,
        text: 'H1',
        ul: [
          {
            text: 'H1',
            tip: 'h1',
            action: 'insertTitle',
            level: 1,
          },
          {
            text: 'H2',
            tip: 'h2',
            action: 'insertTitle',
            level: 2,
          },
          {
            text: 'H3',
            tip: 'h3',
            action: 'insertTitle',
            level: 3,
          },
          {
            text: 'H4',
            tip: 'h4',
            action: 'insertTitle',
            level: 4,
          },
        ],
      },
      {
        foldIndex: 4,
        text: '—',
        ul: [
          {
            text: '—',
            tip: 'hr',
            action: 'insertHRule',
          },
          {
            fa: 'link',
            tip: 'link',
            action: 'openLinkModal',
          },
          {
            fa: 'youtube-play',
            tip: 'video',
            action: 'openVideoModal',
          },
        ],
      },
      {
        foldIndex: 1000,
        text: 'Σ',
        tip: 'math-formula',
        action: 'openFormulaModal',
        speStyle: 'formula',
      },
      {
        foldIndex: 1,
        fa: 'undo',
        ul: [
          {
            fa: 'undo',
            tip: 'undo',
            action: 'undo',
          },
          {
            fa: 'repeat',
            tip: 'redo',
            action: 'redo',
          },
        ],
      },
      {
        foldIndex: 1000,
        fa: 'history',
        tip: 'history',
        action: 'to-history',
      },
      {
        foldIndex: 1000,
        fa: 'volume-up',
        tip: 'audio',
        action: 'openAudioModal',
      },
      {
        foldIndex: 1000,
        fa: 'volume-off',
        tip: 'audioExist',
        action: 'openAudioModal',
      },
      {
        foldIndex: 1000,
        fa: 'expand',
        tip: 'expand',
        action: 'to-fullscreen',
        float: true,
      },
      {
        foldIndex: 1000,
        fa: 'compress',
        tip: 'compress',
        action: 'exit-fullscreen',
        float: true,
      },
      {
        foldIndex: 1000,
        fa: 'floppy-o',
        tip: 'save',
        action: 'auto-save',
        float: true,
      },
    ];
    this.state = {
      isHoverInPubBtn: false, // 鼠标是否在发布按钮上
      curHoveringIndex: -1, // 鼠标正在hover的toolitem index
      curFoldIndex: 0, // 小于等于这个数字的都需要折叠
    };

    if (isFirefox()) {
      this.markDownToolItems = this.markDownToolItems.filter((item) => {
        const { action } = item;
        return action !== 'redo' && action !== 'undo';
      });
    }
    // format the richTextToolItems
    if (isWritingMode) {
      this.richTextToolItems.splice(-3, 1);
      this.markDownToolItems.splice(-4, 1);
    } else {
      this.richTextToolItems.splice(-2, 1);
      this.markDownToolItems.splice(-3, 1);
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler, false);
    this.calculateFoldIndex(); // 初次计算
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler, false);
  }

  resizeHandler = () => {
    this.calculateFoldIndex();
  };

  menuListOnMouseEnter = (e) => {
    clearTimeout(this.hideSubmenuTimer);
    const index = e.currentTarget.getAttribute('data-index');
    this.setState({ curHoveringIndex: +index });
  };

  menuListOnMouseLeave = (e) => {
    this.hideSubmenuTimer = setTimeout(() => {
      this.setState({ curHoveringIndex: -1 });
    }, 50);
  };

  // 计算当前折叠的秩序值
  calculateFoldIndex = () => {
    const { richTextToolItems } = this;
    let resultFoldIndex = this.state.curFoldIndex;
    const spacing = 170;
    const itemWidth = 50;
    const barWidth = this.toolBar.offsetWidth - spacing;
    // Don't resize toolBar too often
    if (this.lastBarWidth !== barWidth) {
      this.lastBarWidth = barWidth;
      let btnCount = richTextToolItems.length;
      richTextToolItems.map((v) => {
        if (v.ul) {
          btnCount += (v.ul.length - 1);
        }
        return null;
      });
      const itemsClone = Immutable.fromJS(richTextToolItems).toJS();
      itemsClone.sort((a, b) => a.foldIndex - b.foldIndex); // foldIndex从小到大排序
      let curBarWidth = btnCount * itemWidth; // max width
      resultFoldIndex = 0; // 默认全部展开
      itemsClone.map((v) => {
        if (barWidth < curBarWidth && v.ul) {
          resultFoldIndex = v.foldIndex;
          curBarWidth -= (v.ul.length - 1) * itemWidth;
        }
        return null;
      });
    }
    // 设置
    this.setState({
      curFoldIndex: resultFoldIndex,
    });
  };

  onToolItemClick = (e) => {
    const { onToolItemClick, getCurLinkInfo } = this.props;
    const action = e.target.getAttribute('data-action');
    const level = e.target.getAttribute('data-level');
    onToolItemClick(action, { level });
  };

  renderToolItems() {
    const { isMarkDown, isAudioExist } = this.props;
    const { markDownToolItems, richTextToolItems } = this;
    const items = isMarkDown ? markDownToolItems : richTextToolItems;
    const { curHoveringIndex, curFoldIndex } = this.state;
    return items.map((v, k) => {
      const isFold = v.foldIndex <= curFoldIndex;
      const isHover = curHoveringIndex === k;
      const itemClasses = classNames(
        'fa', `fa-${v.fa}`,
        {
          [styles['submenu-fake-item']]: isFold && v.ul,
          [styles['hidden']]: !isFold && v.ul,
          [styles['audio-exist']]: v.fa === 'volume-off',
          [styles[`${v.speStyle}`]]: !!v.speStyle,
        },
      );
      const inlineMenuClasses = classNames({
        [styles['hidden']]: isFold,
        [styles['submenu']]: isFold && isHover, // 折叠时选中的样式
        // [styles['inline-menu']]: , // 非折叠的样式
      });
      const listClasses = classNames(
        styles['menu-list'],
        {
          [styles['float-r']]: v.float,
          [styles['hidden']]: (v.tip === 'audioExist' && !isAudioExist) || (v.tip === 'audio' && isAudioExist),
        },
      );
      return (
        <li
          key={k}
          className={listClasses}
          onMouseEnter={this.menuListOnMouseEnter}
          onMouseLeave={this.menuListOnMouseLeave}
          data-index={k}
          onClick={this.onToolItemClick}
        >
          {v.ul ?
            <a className={itemClasses} data-action={v.action}>{v.text}</a> : (
              <Tooltip title={i18n.get(`tooltip.${v.tip}`).d('v.tip')} mouseLeaveDelay={0}>
                <a className={itemClasses} data-action={v.action}>{v.text}</a>
              </Tooltip>
            )}
          {
            v.ul &&
            <ul className={inlineMenuClasses}>
              {
                v.ul.map((item, j) => {
                  return (
                    <li key={j}>
                      <Tooltip
                        title={i18n.get(`tooltip.${item.tip}`).d('item.tip')}
                        mouseLeaveDelay={0}
                        placement={isFold ? 'right' : 'top'}
                      >
                        <a
                          className={classNames('fa', `fa-${item.fa}`)}
                          data-action={item.action}
                          data-level={item.level}
                        >
                          {item.text}
                        </a>
                      </Tooltip>
                    </li>
                  );
                })
              }
            </ul>
          }
        </li>
      );
    });
  }

  pubBtnOnClick = (e) => {
    const { onToolItemClick } = this.props;
    const action = e.currentTarget.querySelector('a').getAttribute('data-action');
    onToolItemClick(action);
  };

  pubBtnOnMouseEnter = () => {
    clearTimeout(this.pubBtnTimer);
    this.setState({ isHoverInPubBtn: true });
  };

  pubBtnOnMouseLeave = () => {
    this.pubBtnTimer = setTimeout(() => {
      this.setState({ isHoverInPubBtn: false });
    }, 50);
  };

  renderPublishBtnContent = () => {
    const {
      isPaidNote,
      isNoteShared,
      contentChanged,
      isPublishing,
      isAutoSaving,
    } = this.props;
    const { isHoverInPubBtn } = this.state;
    // 正在发布中
    if (isPublishing) {
      return (
        <a data-action="publishing">
          <img
            className={styles['loader-tiny']}
            alt="Tiny"
            src={loadingImg}
          />
          {i18n.get('pubbtn.publishing')}
        </a>
      );
    }
    // 正在保存中
    if (isAutoSaving) {
      return (
        <a>
          <img alt="Tiny" className={styles['loader-tiny']} src={loadingImg}/>
          {i18n.get('pubbtn.saving')}
        </a>
      );
    }
    // 已发布的文章
    if (isNoteShared) {
      if (contentChanged) {
        // 发布更新(分为付费文章和普通文章)
        if (isPaidNote) {
          return (
            <a data-action="compile-paid-note">
              <i className="fa fa-mail-forward"/> {i18n.get('pubbtn.compile-paid-note')}
            </a>
          );
        }
        return (
          <a data-action="compile">
            <i className="fa fa-refresh"/> {i18n.get('pubbtn.publish-update')}
          </a>
        );
      }
      // 取消发布
      return (
        <div>
          <a
            data-action="privatize"
            className={classNames({ [styles['hidden']]: isHoverInPubBtn })}
          >
            <i className="fa fa-check"/> {i18n.get('pubbtn.publicized')}
          </a>
          <a
            data-action="privatize"
            className={classNames({ [styles['hidden']]: !isHoverInPubBtn })}
          >
            <i className="fa fa-times"/> {i18n.get('pubbtn.cancel-publish')}
          </a>
        </div>
      );
    }
    // 第一次发布(未发布的文章)
    if (isPaidNote) {
      return (
        <a data-action="publicize-paid-note">
          <i className="fa fa-mail-forward"/> {i18n.get('pubbtn.publicize-paid-note')}
        </a>
      );
    }
    return (
      <a data-action="publicize">
        <i className="fa fa-mail-forward"/> {i18n.get('pubbtn.publicize')}
      </a>
    );
  };

  render() {
    const {
      customerClass,
      isWritingMode,
      isPaidNote,
      isNoteShared,
      contentChanged,
      wordNum,
    } = this.props;
    const toolBarClasses = classNames(customerClass, styles['tool-bar'], 'clearfix');
    const pubBtnClass = classNames(
      styles['float-r'],
      styles['pub-btn'],
      {
        [styles['paid-pub-btn']]: isPaidNote && (isNoteShared ? contentChanged : true),
      },
    );
    return (
      <ul
        className={toolBarClasses}
        ref={(toolBar) => {
          this.toolBar = toolBar;
        }}
      >
        <li
          className={pubBtnClass}
          onMouseEnter={this.pubBtnOnMouseEnter}
          onMouseLeave={this.pubBtnOnMouseLeave}
          onClick={this.pubBtnOnClick}
        >
          {this.renderPublishBtnContent()}
        </li>
        {this.renderToolItems()}
        {
          isWritingMode &&
          <span className={classNames(styles['float-r'], styles['word-num'])}>
            {i18n.get('notes.save-word', { wordNum })}
          </span>
        }
      </ul>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditorToolBar/EditorToolBar.js